// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ExploreHeader,
    ExploreHeaderFromJSON,
    ExploreHeaderToJSON,
    FeaturedItems,
    FeaturedItemsFromJSON,
    FeaturedItemsToJSON,
} from '../models';

export interface ReadRequest {
    id: string;
}

/**
 * no description
 */
export class ExploreApi extends runtime.BaseAPI {

    /**
     * Return the explore header
     */
    async headerRaw(): Promise<runtime.ApiResponse<ExploreHeader>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("LabXChange API", ["read", "write"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/explore/header`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ExploreHeaderFromJSON(jsonValue));
    }

    /**
     * Return the explore header
     */
    async header(): Promise<ExploreHeader> {
        const response = await this.headerRaw();
        return await response.value();
    }

    /**
     * Return every featured item metadatas
     */
    async readRaw(requestParameters: ReadRequest): Promise<runtime.ApiResponse<FeaturedItems>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling read.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("LabXChange API", ["read", "write"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/explore/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FeaturedItemsFromJSON(jsonValue));
    }

    /**
     * Return every featured item metadatas
     */
    async read(requestParameters: ReadRequest): Promise<FeaturedItems> {
        const response = await this.readRaw(requestParameters);
        return await response.value();
    }

}
